import { Component, Vue, Watch } from "vue-property-decorator";
import { JwtClaims } from "@/store/modules/auth";
import { Getter } from "vuex-class";

@Component
export default class GlobalFilterSensitiveMixin extends Vue {
  globalPropertiesFilterKey = 0;
  @Getter("globalFilters/filteredProperties") globalPropertiesFilter?: any[];

  @Watch("globalPropertiesFilter")
  watchGlobalPropertiesFilter() {
    this.globalPropertiesFilterKey++;
  }

  @Getter("auth/claims") claims?: JwtClaims;

  get sensitiveKey() {
    return (this.claims?.tid || 0) + "_" + this.globalPropertiesFilterKey;
  }
}
